import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
    '& .modal-base-content': {
        padding: 16,
        '& .MuiFormControl-root': {
            '& label': {
                textTransform: 'capitalize',
            },
        },
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px 24px',
    gridTemplateAreas: '"input1" "select0" "select2"',
    gridTemplateColumns: '100%',
    '& .companies-autocomplete': {
        gridArea: 'select0',
    },
});

export const CheckboxWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    height: 40,
    '& .MuiCheckbox-root': {
        padding: 4,
    },
});
